import { List } from 'immutable';
import useRedux from 'infrastructure/js/hooks/useRedux';
import Header, {headerItemsLabels} from '../../../Common/Header/header';
import {gridsNames} from '../../../../enums/gridsNames.js';
import QplTestsViewGrid from '../QplTestsView/QplTestsViewGrid/qplTestsViewGrid';
import {jsxActions as headerSettingsActions} from '../../../../actions/Header/headerSettingsActions';
import {jsxActions as qplTestsViewActions } from '../../../../actions/Administration/MatSettingsPage/qplTestsViewActions';
import {jsxActions as qplTestsViewGridActions} from '../../../../actions/Administration/MatSettingsPage/qplTestsViewGridActions';
import {jsxActions as fetchEntitiesActions} from '../../../../actions/FetchEntities/fetchEntitiesActions';
import { jsxActions as matSettingsPageActions } from '../../../../actions/Administration/MatSettingsPage/matSettingsPageActions.js';

import './qplTestsView.scss';


const getState = (state) => {
  let grid = state.grid?.get(gridsNames.ADMINISTRATION_MAT_SETTINGS_QPL_TESTS) || null;

  return {
    sHasRows: grid?.get('rows')?.size > 0 || false,
    sSelectedRowsData: grid?.get('selectedRowsData') || List(),
  };
};

const allActions = {
  headerSettingsActions,
  qplTestsViewActions,
  qplTestsViewGridActions,
  fetchEntitiesActions,
  matSettingsPageActions: matSettingsPageActions,
};

export default function QplTestsView(props) {

  const { state, actions } = useRedux(allActions, getState);
  const {sHasRows = false, sSelectedRowsData } = state;


  const getHeaderItems = () => {
    return  {
      buttons: [
        {
          id: 'clearFilters',
          label: '',
          icon: 'pl pl-filter-clear',
          action: actions.qplTestsViewActions.clearFilters,
          tooltip: headerItemsLabels.CLEAR_FILTERS,
        },
        {
          id: 'refresh',
          label: '',
          icon: 'pl pl-refresh',
          action: actions.qplTestsViewActions.reload,
          tooltip: headerItemsLabels.REFRESH,
        },
        {
          id:'create',
          label: headerItemsLabels.CREATE,
          icon: 'pl pl-icon-add',
          action: () => {
            props.history.push(`/Administration/matSettings/qualityProductLists/${props.qplId}/qplTestForm`)
          },
        },
        {
          id:'edit',
          label: headerItemsLabels.EDIT,
          icon: 'pl pl-edit-icon',
          disabled: !(sHasRows && sSelectedRowsData?.size === 1),
          action: () => {
            props.history.push(`/Administration/matSettings/qualityProductLists/${props.qplId}/qplTestForm/${sSelectedRowsData.get(0)?.id}/edit`)
          },
        },
        ],
      kebab: {
        menuItems: [
          // {   //TODO: L QPL - currently not supported
          //   id:'preview',
          //   label: headerItemsLabels.PREVIEW,
          //   // action: () => {
          //   //   props.history.push(`${props.match.url}/qplForm/${sSelectedRowsData.get(0)?.id}/clone`)
          //   // },
          //   disabled: true,
          // },
          {
            id:'clone',
            label: headerItemsLabels.CLONE,
            action: () => {
              props.history.push(`/Administration/matSettings/qualityProductLists/${props.qplId}/qplTestForm/${sSelectedRowsData.get(0)?.id}/clone`)
            },
            disabled: !(sHasRows && sSelectedRowsData?.size === 1),
          },
          {
            id:'remove',
            label: headerItemsLabels.DELETE,
            action: actions.qplTestsViewActions.removeQplTests,
            disabled: (!sSelectedRowsData || sSelectedRowsData.size === 0),
            actionData:  sSelectedRowsData?.toJS() ?? [],
          },
        ]
      }
    };
  }

  return (
    <div className="administration-view qpl-test-view">

      <Header {...getHeaderItems()}/>

      <QplTestsViewGrid actions={{...actions.qplTestsViewGridActions, ...actions.fetchEntitiesActions}} />

    </div>
  )
}



